import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { css, TooltipHost, TooltipOverflowMode, mergeStyleSets } from '@fluentui/react';
import { __Consolidation, enum__Consolidation } from '../../../../../../common/Dictionaries';
import { useSelector } from 'react-redux';
import { calulateSystenDecimal, formatNumber, isNullOrEmpty, isNullUndefined } from '../../../../../../common/Helpers';

function ItemGroup(props) {
  	const { t } = useTranslation();

    //Parametros de entrada.
    const { 
        inputParam_Object = null,
    } = props;

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });

    const generateDom = () => {
        return inputParam_Object &&
            <>
                <div className='border ps-1 w-100 d-flex'>
                        <div className='px-0 d-flex' style={{width: "100%"}}>
                            <div className='px-0 me-auto my-auto w-100' style={{fontSize: "11px"}}>
                                <div className='my-1 ps-0 pe-1 text-start'>
                                    <TooltipHost
                                        overflowMode={TooltipOverflowMode.Self}
                                        hostClassName={css(classNames.overflow)}
                                        content={ inputParam_Object.name }
                                        onTooltipToggle={false}
                                        styles={{
                                            root: { display: 'block', height: "33px", position: "relative" },
                                        }}
                                    >
                                        <div style={{fontSize: "15px", position: "absolute", top: "50%", transform: "translateY(-50%)", height: (inputParam_Object.name.length <= 44 ? "auto" : "33px")}}>
                                            {inputParam_Object.name}
                                        </div>
                                    </TooltipHost> 
                                </div>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='px-0 my-auto' style={{width: "100%"}}>
                                <div style={{width: "120px"}}>
                                    <TooltipHost content={ !isNullUndefined(inputParam_Object.scopeValue) ? `${inputParam_Object.scopeValue}%` : t('no-data') } >
                                        <div className={`cursor-pointer border my-1 px-2 text-center ${ " variable-value-color-" + inputParam_Object.color } `}>
                                            {`${!isNullUndefined(inputParam_Object.scopeValue) ? `${formatNumber(inputParam_Object.scopeValue)}%` : t('no-data')}`}
                                        </div>
                                    </TooltipHost> 
                                </div>
                            </div>
                        </div>
                </div>
            </>
    }

    return (
        <>
            { generateDom() }
        </>
    );
}

ItemGroup.propTypes = {
    inputParam_Object: PropTypes.object.isRequired,
};

export default ItemGroup;